// extracted by css-extract-rspack-plugin
var _1 = "eBYtcN22V4DQlW4w";
var _2 = "eBYtcN22V4DQlW4w";
var _3 = "LxGHyEr6pj86Ys9t";
var _4 = "LxGHyEr6pj86Ys9t";
var _5 = "ntOVYeL_4tg85rfI";
var _6 = "K1NjU1MW374yYhFX";
var _7 = "ntOVYeL_4tg85rfI";
var _8 = "K1NjU1MW374yYhFX";
var _9 = "YzVOf3f8bqwjZReL";
var _a = "HBU9zBq5zuoUfZ99";
var _b = "HBU9zBq5zuoUfZ99";
export { _1 as "acc-group", _2 as "accGroup", _3 as "price-btn", _4 as "priceBtn", _5 as "tab-box", _6 as "tab-panel", _7 as "tabBox", _8 as "tabPanel", _9 as "ticketsprices", _a as "ticketsprices-title", _b as "ticketspricesTitle" }
